import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

export const transactionsApiTemplateSlice = createApi({
  reducerPath: 'transactionsApi',
  baseQuery: restBaseQuery(appConfiguration.simplepay.api.url),
  endpoints: () => ({}),
});

export const {
  reducer: transactionsReducer,
  reducerPath: transactionsReducerPath,
  middleware: transactionsMiddleware,
} = transactionsApiTemplateSlice;
